var bighouse = bighouse || {};

bighouse.compare = (function () {


    function init() {
        initCarousel();

        $('.js-compareChange').on('click', function(e){
            openDrawer();
            e.preventDefault();
        });

        $('.js-lightboxCloseDrawer').on('click', function(){
            closeDrawer();
            e.preventDefault();
        });
    }

    function initCarousel(){

        var activeIndex = $( '.js-compareTrack .Compare-slide' ).index( $('.Compare-slide--active') );

        $('.js-compareTrack').slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: false,
            focusOnSelect: false,
            infinite: false,
            autoplay: false,
            centerMode: true,
            rows: 0,
            prevArrow: '<button class="Compare-button Compare-button--carousel Compare-button--prev"><span class="u-visuallyHidden">View previous dates</span><img src="/assets/img/compare/previous.svg" alt="previous calendar item"></button>',
            nextArrow: '<button class="Compare-button Compare-button--carousel Compare-button--next"><span class="u-visuallyHidden">View next dates</span><img src="/assets/img/compare/next.svg" alt="next calendar item"></button>',
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },

                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
        });

        $('.js-compareTrack').slick('slickGoTo', activeIndex, true);

        resizeFunc();

        var debounceResize = util.debounce(resizeFunc, 100);
        $(window).on('resize', debounceResize);
    }


    function resizeFunc() {
        $('.Compare-slide').css('height', 'auto');

        $('.js-compareTrack').each(function(e){
            var thisheight = $(this).height();
            $(this).find('.Compare-slide').css('height', thisheight + 'px');
        });
    
    }


    function openDrawer(){

    }

    function closeDrawer(){
        
    }


    

    return {
        init: init
    };
})();